export const IFRAME_CONTAINER_CLASS = 'bf-iframe-container';
export const TRIGGER_BUTTON_CLASS = 'bf-trigger-button';
